var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CellRenderer } from './cell-renderer';
/**
 * PinnedRowIndentCellRenderer class which responsible for building indent cell for pinned rows at top.
 *
 * @hidden
 */
var PinnedRowIndentCellRenderer = /** @class */ (function (_super) {
    __extends(PinnedRowIndentCellRenderer, _super);
    function PinnedRowIndentCellRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = _this.parent.createElement('TD', {
            className: 'e-pindentcell',
            attrs: { tabindex: '-1', role: 'gridcell' }
        });
        return _this;
    }
    /**
     * Function to render the pinned row indent cell.
     *
     * @param  {Cell} cell - specifies the cell
     * @param  {Object} data - specifies the data
     * @returns {Element} returns the element
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PinnedRowIndentCellRenderer.prototype.render = function (cell, data) {
        var node = this.element.cloneNode();
        node.appendChild(this.parent.createElement('div', { className: 'e-emptycell', innerHTML: '' }));
        if (cell) {
            if (cell.rowSpan) {
                node.setAttribute('rowspan', cell.rowSpan.toString());
            }
            if (cell.rowSpan === 0) {
                node.style.display = 'none';
            }
        }
        return node;
    };
    return PinnedRowIndentCellRenderer;
}(CellRenderer));
export { PinnedRowIndentCellRenderer };
